import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kothrudtomumbaicab() {



const cardData = {
  keyword: " Kothrud to Mumbai Cabs ",

headingDescription:
  "Velocity Cab provides reliable and comfortable Kothrud to Mumbai cab services, ensuring a hassle-free and smooth journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Kothrud to Mumbai convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Kothrud to Mumbai cab travel.",

topPlaces: [
  
  {
    title: "Powai Lake",
    description: "Powai Lake is a picturesque urban lake surrounded by gardens, restaurants, and modern city landmarks. Hiring an Innova Crysta on rent in Pune provides a smooth journey for families and groups looking to enjoy lakeside views, peaceful walks, boating, and quality leisure time in one of Mumbai's most attractive neighborhoods."
  },
  {
    title: "Flora Fountain",
    description: "Flora Fountain is a magnificent Victorian monument located in the heart of South Mumbai and surrounded by heritage buildings and bustling business districts. Travelers booking an Innova Crysta on rent in Pune can comfortably explore this iconic landmark while visiting nearby shopping streets, cafés, and colonial-era architecture. It is a great destination for history enthusiasts, photographers, and anyone interested in Mumbai's rich heritage."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive is one of Mumbai's most scenic waterfront promenades, offering breathtaking views of the Arabian Sea and the city's skyline. Visitors choosing an Innova Crysta on rent in Pune can enjoy a comfortable road trip before relaxing by the coastline, taking evening walks, and witnessing the famous sunset that makes Marine Drive one of Mumbai's top attractions."
  },
  {
    title: "Film City, Goregaon",
    description: "Film City in Goregaon is the center of India's entertainment industry and home to numerous Bollywood movie and television sets. Renting an Innova Crysta in Pune makes the journey convenient for families and groups interested in guided studio tours, film sets, and behind-the-scenes experiences of India's vibrant film industry."
  },

  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is a remarkable meditation monument featuring one of the world's largest stone domes. Travelers booking an Innova Crysta on rent in Pune can enjoy a scenic drive to this peaceful destination near Gorai and experience meditation, spiritual learning, and impressive architecture surrounded by serene landscapes."
  },
    {
    title: "Colaba Causeway",
    description: "Colaba Causeway is one of Mumbai's most vibrant shopping destinations, offering fashion accessories, handicrafts, antiques, cafés, and street food. Travelers hiring an Innova Crysta on rent in Pune can comfortably explore this lively market while enjoying local shopping and discovering the charm of South Mumbai."
  },
  {
    title: "Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park is a vast green oasis within Mumbai, famous for its wildlife, cycling trails, boating, and lush forests. Booking an Innova Crysta on rent in Pune ensures a comfortable drive to this natural attraction, making it an excellent destination for families, adventure lovers, and nature enthusiasts."
  },
  {
    title: "Hanging Gardens",
    description: "Hanging Gardens on Malabar Hill are beautifully landscaped terraced gardens offering panoramic views of the Arabian Sea and Marine Drive. Travelers choosing an Innova Crysta on rent in Pune can relax amidst well-maintained greenery, unique topiary displays, and peaceful surroundings while enjoying one of Mumbai's most scenic viewpoints."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is among Mumbai's most popular coastal attractions, known for its lively atmosphere, delicious street food, and spectacular sunsets. Visitors renting an Innova Crysta in Pune can comfortably travel to Mumbai and spend quality time enjoying beach walks, local snacks, and family-friendly entertainment."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's most iconic historical monument overlooking the Arabian Sea. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this famous landmark, admire its magnificent architecture, enjoy ferry rides to nearby attractions, and capture unforgettable photographs at one of India's most recognized tourist destinations."
  }
],



services: [
{
name: "Kothrud to Mumbai Airport Cab",
description: "Kothrud to Mumbai Airport cab service offers reliable transportation from Kothrud in Pune to Mumbai Airport terminals. Comfortable vehicles with professional drivers ensure safe travel via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, and residential societies across Kothrud. Ideal for business travelers, tourists, and families needing timely airport transfers."
},
{
name: "Kothrud to Mumbai International Airport Cab",
description: "Kothrud to Mumbai International Airport cab service provides dependable airport transportation to Chhatrapati Shivaji Maharaj International Airport. Vehicles are spacious and suitable for passengers traveling with luggage. Professional drivers ensure punctual pickups and safe expressway travel from Kothrud and nearby areas."
},
{
name: "Kothrud to Mumbai One Way Cab",
description: "Kothrud to Mumbai one way cab service provides convenient single-trip transportation between Pune and Mumbai. Comfortable sedan and SUV vehicles are available for safe expressway journeys. Pickup services are available from homes, offices, and hotels across Kothrud."
},
{
name: "Kothrud to Mumbai Drop Taxi",
description: "Kothrud to Mumbai drop taxi service offers reliable one-way transportation for passengers traveling from Kothrud to Mumbai city. Vehicles are comfortable and suitable for highway travel with experienced drivers ensuring safe journeys."
},
{
name: "Kothrud to Dadar Taxi Service",
description: "Kothrud to Dadar taxi service provides convenient transportation between Pune’s Kothrud area and Dadar in Mumbai. Vehicles are suitable for expressway travel with professional drivers ensuring safe and timely journeys."
},
{
name: "Kothrud to Bandra Taxi Service",
description: "Kothrud to Bandra taxi service offers dependable transportation between Kothrud and Bandra in Mumbai. Vehicles provide comfortable seating and smooth highway travel for business trips, tourism visits, and family journeys."
},
{
name: "Kothrud to Mumbai Darshan Cab",
description: "Kothrud to Mumbai darshan cab service offers sightseeing travel options for passengers visiting famous locations in Mumbai. Comfortable vehicles with professional drivers ensure safe and enjoyable city tours."
},
{
name: "Pune to Mumbai Taxi",
description: "Pune to Mumbai taxi service provides reliable intercity transportation between Pune and Mumbai. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides dependable airport transportation for travelers heading from Pune city to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport journeys."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation for passengers traveling between Pune and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for expressway travel."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for comfortable long-distance travel. Innova vehicles offer spacious seating and smooth ride quality suitable for expressway journeys."
},
{
name: "Kothrud to Mumbai Cab Service",
description: "Kothrud to Mumbai cab service offers dependable transportation between Kothrud in Pune and Mumbai city. Vehicles are comfortable and suitable for highway travel with experienced drivers ensuring safe journeys."
},
{
name: "Kothrud to Mumbai Innova Cab Service",
description: "Kothrud to Mumbai Innova cab service offers premium SUV travel for passengers seeking spacious and comfortable highway transportation. The Innova vehicle ensures smooth journeys with professional drivers."
},
{
name: "Kothrud to Andheri Cab Service",
description: "Kothrud to Andheri cab service provides reliable transportation between Pune and Mumbai’s Andheri area. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Innova Crysta on Rent in Kothrud Pune",
description: "Innova Crysta on rent in Kothrud Pune offers premium SUV rental for travelers seeking luxury transportation. The Innova Crysta provides spacious seating and smooth ride quality suitable for long-distance travel and airport transfers."
},
{
name: "Toyota Innova Crysta Car Hire in Pune",
description: "Toyota Innova Crysta car hire in Pune provides luxury SUV rental for corporate travel, family trips, and airport transfers. Spacious seating and powerful performance make the vehicle ideal for highway travel."
},
{
name: "Pune Mumbai Velocity Cabs",
description: "Pune Mumbai Velocity Cabs service offers dependable transportation between Pune and Mumbai. Comfortable vehicles and professional drivers ensure safe expressway travel for passengers."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel across Pune."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service offers reliable intercity transportation between Pune and Mumbai. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Cab Service in Kothrud",
description: "Cab service in Kothrud provides dependable transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe rides across Kothrud and nearby Pune areas."
},
{
name: "Kothrud to Outstation Cabs Service",
description: "Kothrud to outstation cabs service offers reliable transportation from Kothrud to nearby cities and tourist destinations. Comfortable vehicles with professional drivers ensure safe highway travel."
},
{
name: "Kothrud to Mumbai Cabs",
description: "Kothrud to Mumbai cabs service provides reliable transportation between Kothrud in Pune and Mumbai city. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Kothrud to Mumbai Taxi",
description: "Kothrud to Mumbai taxi service provides convenient transportation for travelers heading from Pune to Mumbai. Comfortable vehicles and professional drivers ensure safe and smooth highway journeys."
},
{
name: "Kothrud to Mumbai Taxi Service",
description: "Kothrud to Mumbai taxi service offers dependable intercity transportation between Pune and Mumbai. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys."
}
],

tableData: [
["Kothrud to Mumbai Airport Cab","Kothrud to Mumbai International Airport Cab"],
["Kothrud to Mumbai One Way Cab","Kothrud to Mumbai Drop Taxi"],
["Kothrud to Dadar Taxi Service","Kothrud to Bandra Taxi Service"],
["Kothrud to Mumbai Darshan Cab","Pune to Mumbai Taxi"],
["Pune to Mumbai Airport Cab","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Kothrud to Mumbai Cab Service"],
["Kothrud to Mumbai Innova Cab Service","Kothrud to Andheri Cab Service"],
["Innova Crysta on Rent in Kothrud Pune","Toyota Innova Crysta Car Hire in Pune"],
["Pune Mumbai Velocity Cabs","Cab Service in Pune"],
["Pune Mumbai Cab","Cab Service in Kothrud"],
["Kothrud to Outstation Cabs Service","Kothrud to Mumbai Cabs"],
["Kothrud to Mumbai Taxi","Kothrud to Mumbai Taxi Service"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Kothrud to Mumbai via the Mumbai Pune Expressway. Their knowledge of traffic routes and highway conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Kothrud to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Kothrud to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, corporate travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Kothrud to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Kothrud",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and residential societies across Kothrud and nearby areas like Bavdhan, Karve Nagar, Warje, and Paud Road."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Kothrud to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Kothrud to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Kothrud to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Kothrud to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Kothrud to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Kothrud to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Kothrud and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and residential societies across Kothrud." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Kothrud to Mumbai cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Swapnil Joshi",
    feedback:
      "The Kothrud to Mumbai ride was very comfortable and well-coordinated. The cab was on time, the seating was good, and the journey felt smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Madhuri Patil",
    feedback:
      "Traveling from Kothrud to Mumbai was a pleasant experience. The vehicle was clean, the drive was steady, and the overall service felt reliable and well-managed.",
    rating: 5
  }
];







































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kothrud to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Kothrud to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Ertiga, Innova, and Innova Crysta for airport transfers, Dadar, Bandra, Andheri, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Kothrud to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      <Helmet>
  <title>Kothrud to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Kothrud to Mumbai cab with Velocity Cabs. Affordable taxi service for one way, round trip & airport drop. Ertiga, Innova & Crysta cabs available for Dadar, Bandra, Andheri & other Mumbai destinations." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kothrudtomumbaicab;